import { useSelector } from "react-redux";

import { Grid, TextField } from "@mui/material";

export default function LitcoTextField(props) {
  const {
    xs,
    sm,
    md,
    lg,
    xl,
    mt,
    mb,
    value,
    label,
    select,
    helperText,
    size,
    disabled,
    fontSize,
    maxLength,
    multiline,
    rows,
    type,
    pattern,
    variant,
    required,
    onChange,
    onFocus,
    onBlur,
    onClick,
    labelStyle,
    fullWidth,
    width,
  } = props;

  const globalLoading = useSelector((state) => state.loading.active); //Fields are automatically disabled if API is in use

  let name;
  const isTextLabel = typeof label === "string";

  if (!props.name) {
    name = label.replaceAll(" ", "");
    name = name.charAt(0).toLowerCase() + name.substring(1);
  } else {
    name = props.name;
  }

  const field = (
    <TextField
      name={name}
      label={isTextLabel ? label : undefined}
      select={select !== undefined}
      fullWidth={fullWidth ?? true}
      value={value}
      variant={variant ?? "standard"}
      helperText={helperText}
      size={size}
      disabled={disabled || globalLoading}
      multiline={multiline}
      rows={rows}
      required={required}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      onClick={onClick}
      inputProps={{ style: { fontSize }, maxLength, inputMode: type, pattern }}
      InputLabelProps={{ style: labelStyle }}
      key={name}
      sx={{ width }}
    >
      {select}
    </TextField>
  );

  if (xs || sm || md || lg || xl) {
    return (
      <Grid item xs={xs} sm={sm} md={md} lg={lg} xl={xl} mt={mt} mb={mb}>
        {!isTextLabel && label}
        {field}
      </Grid>
    );
  } else {
    return (
      <>
        {!isTextLabel && label} {field}
      </>
    );
  }
}
